import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'omId',
    moduleType: 'OM',
    name: '组织模块',
    type: 'CAT_ROOT_OM',
}
